import {css} from 'styled-components';

// retina
export const break_point_pc_ = "(min-width:768px)";
export const break_point_sp_ = "(max-width:767px)";

//css
export const break_point_pc = "only screen and (min-width:768px)";
export const break_point_sp = "only screen and (max-width:767px)";

export const widthPc = 1200;
export const widthSp = 750;
export const widthContsPc = 1000;
export const widthContsSp = 656;

//==============================
//		font
//==============================
//------------------------------
//		font-family
//------------------------------
export const font_gothic = css`
  font-family: "Hiragino Kaku Gothic ProN", "ヒラギノ角ゴ ProN W3", "メイリオ", Meiryo, "ＭＳ Ｐゴシック", "MS PGothic", sans-serif !important;
`;
export const font_mincho = css`
  font-family: "Hiragino Mincho ProN", "ヒラギノ明朝 ProN W3", "游明朝", YuMincho, "HG明朝E", "ＭＳ Ｐ明朝", "ＭＳ 明朝", serif !important;
`;

//------------------------------
//		font-size
//------------------------------
export const fs_default_pc = css`
	font-size: 1.6rem;
	line-height: 1.6;
`;
export const fs_large_pc = css`
	font-size: 1.8rem;
	line-height: 1.6;
`;
export const fs_small_pc = css`
	font-size: 1.4rem;
	line-height: 1.6;
`;
export const fs_default_sp = css`
	font-size: 1.6rem;
	line-height: 1.6;
`;
export const fs_large_sp = css`
	font-size: 1.8rem;
	line-height: 1.6;
`;
export const fs_small_sp = css`
	font-size: 1.4rem;
	line-height: 1.6;
`;

//==============================
//		color
//==============================
//------------------------------
//		regular color
//------------------------------
export const color_default = "#000000";
export const color_main = "#ffffff";
//------------------------------
//		background color
//------------------------------
export const bg_default_color = "#ffffff";
export const bg_color_main = "#000000";

//==============================
//		link
//==============================
export const link_style_01 = css`
	color: ${color_main};
	&:hover {
		@include opacity_default;
	}
`;
//==============================
//		transition
//==============================
export const transition_default = css`
	transition: 0.3s;
	-webkit-transition: 0.3s;
	-moz-transition: 0.3s;
	-ms-transition: 0.3s;
	-o-transition: 0.3s;
`;
//==============================
//		opacity
//==============================
export const opacity_default = css`
	filter:alpha(opacity=80);
	-moz-opacity: 0.8;
	opacity: 0.8;
`;
